import { PlayIcon } from 'lucide-react';

import ControlButton from './ControlButton';

function ResumeButton({ onClick }: { onClick: () => void }) {
  return (
    <ControlButton variant="default" onClick={onClick} className="w-36" aria-label="Resume timer">
      <PlayIcon className="size-6" />
    </ControlButton>
  );
}

export default ResumeButton;
